import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./Login";

import Dashboard from "./pages/Dashboard";
import Services from "./pages/Services";
import Expenses from "./pages/Expenses";
import Users from "./pages/Users";
import Setting from "./pages/Setting";

import Casefilecreate from "./pages/Casefilecreate";
import Casefilelist from "./pages/Casefilelist";
import CasefileEdit from "./pages/CasefileEdit";
import PaymentSlip from "./pages/PaymentSlip";

import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>

          {/* LOGIN */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* DASHBOARD */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* USERS */}
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />

          {/* SERVICES */}
          <Route
            path="/services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />

          {/* EXPENSES */}
          <Route
            path="/expenses"
            element={
              <ProtectedRoute>
                <Expenses />
              </ProtectedRoute>
            }
          />

          {/* SETTING */}
          <Route
            path="/setting"
            element={
              <ProtectedRoute>
                <Setting />
              </ProtectedRoute>
            }
          />

          {/* CASE FILE CREATE */}
          <Route
            path="/case-files/create"
            element={
              <ProtectedRoute>
                <Casefilecreate />
              </ProtectedRoute>
            }
          />

          {/* CASE FILE LIST */}
          <Route
            path="/case-files/list"
            element={
              <ProtectedRoute>
                <Casefilelist />
              </ProtectedRoute>
            }
          />

          {/* CASE FILE EDIT */}
          <Route
            path="/casefile-edit/:id"
            element={
              <ProtectedRoute>
                <CasefileEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment-slip"
            element={
              <ProtectedRoute>
                <PaymentSlip />
              </ProtectedRoute>
            }
          />

          {/* DEFAULT */}
          <Route path="/" element={<Navigate to="/login" replace />} />

        </Routes>
      </BrowserRouter>

      <ToastContainer position="top-right" autoClose={2000} theme="colored" />
    </>
  );
}

export default App;